module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d3/main_pc_5df69c23076f5f66db6f469dcdf047ad.jpg";